<template>
<v-container fluid class="secondary">
<v-card elevation="8" class="ma-3 pa-3 primary">
    <v-card-title class="justify-center textTitle--text"><h2>{{ $t('catmanager.catmanagerScreenTitle') }}</h2></v-card-title>
    <v-row class="ma-4 justify-center ">
              <v-btn @click="catForm=true" x-large class="font-weight-black black--text ma-2 pa-2" color="quaterny">{{ $t('catmanager.createCatButton') }}</v-btn>
              </v-row>
    <v-row class="justify-center">
        
            
          <v-col cols=10>  
             <v-treeview
            :items="treeviewCatItems"
            activatable
            :multiple-active="false" 
            return-object
            active-class="textMenu font-weight-black black--text"
            open-all
            expand-icon="mdi-chevron-right secondary quinty--text"
            hoverable
            class="secondary textTitle--text font-weight-black"
          ><template v-slot:append="{ item }">
              <v-chip  class="quaterny mr-5">{{item.qtyprod}}</v-chip>
              
            </template>

            <template v-slot:label="{ item }">
              <v-row align="center" >
              <h3 class="ma-3 pa-3">{{item.name}}</h3>
              <v-btn v-if="item.id!='uncategorized'" @click="addSubCatButton(item)" small class="font-weight-black black--text ma-3 pa-3 ml-8" color="quinty">{{ $t('catmanager.addCatButton') }}</v-btn>
              <v-btn v-if="item.id!='uncategorized'" small @click="deleteCatButton(item)" class="ma-4 font-weight-black black--text" color="error">{{ $t('delete') }}</v-btn>
             <v-btn v-if="item.id!='uncategorized'" small @click="modifCatButton(item)" class="ma-4 font-weight-black black--text" color="textTitle">{{ $t('modify') }}</v-btn>
            </v-row>
            
            </template></v-treeview>
          <v-row class="justify-center">
          
          </v-row> 
       

            <v-dialog :retain-focus='false' width="550px" v-model="errorCatChild">
              <errorMessage @close="errorCatChild=false" :title="'Error'" :message="'No puedes supprimir categoria que tienes categorias secondarias'" :key="errorKey"/>
              
            </v-dialog>
            <v-dialog :retain-focus='false' width="80%" v-model="modifCatDialog">
              <modifCat @close="modifCatClose()" :cat="catactive" :key="modifCatDialogKey" />
              
            </v-dialog>
             <v-dialog :retain-focus='false' width="550px" v-model="confirmDeleteDialog" persistent >
              <confirmMessage @close="confirmDeleteDialog=false" :title="'Error'" :message="'Seguro que quieres supprimir la categoria : '" @confirm="removeselectedcat" :confirmname="catactivename"/>
              
            </v-dialog>

            
        
        
         <v-dialog :retain-focus='false' width="50%" v-model="catForm">
        <v-card v-if="catForm" color="quaterny" class="ma-1 pa-3">
           <v-row class="justify-center align-center">
    <h2 class="font-weight-bold underline text-decoration-underline ma-5 pa-4">{{ $t('catmanager.catName') }}</h2>
    <v-text-field v-model="catname" background-color="quinty" height="60px" color="primary"  rounded class="font-weight-black text-h6 ma-5 pa-4 shrink"></v-text-field>
  </v-row>
  <v-divider></v-divider>
  <v-row class="justify-center align-center">
    <h2 class="font-weight-bold underline text-decoration-underline ma-5 pa-4">{{ $t('catmanager.catDesc') }}</h2>
    <v-textarea v-model="catdesc" auto-grow background-color="quinty" color="primary" rounded class="font-weight-black text-h6 ma-5 pa-4 shrink"></v-textarea>
  </v-row>
            <v-divider></v-divider>
            <v-row class="ma-5 align-center justify-center"><h2 class="ma-2">{{ $t('catmanager.catInvalert') }}</h2>
            <div class="ma-2" width="30%"><v-text-field max=100 min=0 class="font-weight-black text-h5 textMenu--text" type="number" background-color="quinty" filled v-model.number="invAlert"></v-text-field></div>
            </v-row>
            <v-divider></v-divider>
            <v-row class="justify-center"><v-btn @click="addCatToDb" large class="ma-5 pa-5 text-h5 font-weight-black black--text" color="success" >{{ $t('catmanager.addCatButton') }}</v-btn></v-row>
        </v-card>
         </v-dialog>

          <v-dialog :retain-focus='false' width="50%" v-model="subcatForm">
        <v-card v-if="subcatForm" color="quaterny" class="ma-1 pa-3">
            <v-card-title class="justify-center " ><h3>{{ $t('catmanager.catParentCat') }}</h3><v-chip x-large label class=" ml-8 pa-4 ma-4 primary"><h2 class="textTitle--text">{{this.catactive[0].name}}</h2></v-chip></v-card-title>
            <v-divider></v-divider>
            <v-row class="justify-center align-center">
    <h2 class="font-weight-bold underline text-decoration-underline ma-5 pa-4">{{ $t('catmanager.catName') }}</h2>
    <v-text-field v-model="catname" background-color="quinty" height="60px" color="primary"  rounded class="font-weight-black text-h6 ma-5 pa-4 shrink"></v-text-field>
  </v-row>
  <v-divider></v-divider>
  <v-row class="justify-center align-center">
    <h2 class="font-weight-bold underline text-decoration-underline ma-5 pa-4">{{ $t('catmanager.catDesc') }}</h2>
    <v-textarea v-model="catdesc" auto-grow background-color="quinty" color="primary" rounded class="font-weight-black text-h6 ma-5 pa-4 shrink"></v-textarea>
  </v-row>
            <v-divider></v-divider>
            <v-row class="ma-5 align-center justify-center"><h2 class="ma-2">{{ $t('catmanager.catInvalert') }}</h2>
            <div class="ma-2" width="30%"><v-text-field max=100 min=0 class="font-weight-black text-h5 textMenu--text" type="number" background-color="quinty" filled v-model.number="invAlert"></v-text-field></div>
            </v-row>
            
            <v-divider></v-divider>
            <v-row class="justify-center"><v-btn @click="addSubCatToDb" large class="ma-5 pa-5 text-h5 font-weight-black black--text" color="success" >{{ $t('catmanager.addSubCatButton') }}</v-btn></v-row>
        </v-card>
          </v-dialog>
       </v-col>  
    </v-row>
</v-card>
</v-container>
</template>

<script>
import errorMessage from '@/components/errorMessage'
import modifCat from '@/components/modifCat'
import confirmMessage from '@/components/confirmMessage'
import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'


  export default {
      props:[],
      components:{errorMessage, modifCat, confirmMessage},
    data () {
      return {
        catactive:[],

            catname:'',
            catdesc:'',
            invAlert:25,
            subcatForm:false,
            catForm:false,
            errorCatForbiden:false,
            errorCatChild:false,
            errorKey:0,
            modifCatDialog:false,
            modifCatDialogKey:0,
            confirmDeleteDialog:false,
            catactivename:'',
            errorCatForbidenMessage:"",
            treeviewdata:[],

      }
    },
    computed:{
      ...mapGetters({
        treeviewCatItems:'treeviewCatDb'
      })
    },
    mounted(){
        
    },
    methods: {
      ...mapActions([
        'deleteCat',
        'updateCatChildCount',
        'addCat',
        'modifProductCat'
      ]),
        addCatToDb(){
          var name = this.catname;
            var id = 'cat1';
            var catdb = this.$store.state.catdb;        

            if(catdb.length>0){
               
            var size = catdb.length
            var pos=1

            for(var i=1;i<size;i++){
              if(catdb[i].id!=id){continue}else{
                pos+=1
                id='cat'+pos
                i=0
              }
            }
            }
            
            var cat = {
              'id':id,'name':name,'desc':this.catdesc,'children':[],'childs':0,'parentid':'','qtyprod':0,'invAlert':this.invAlert,'level':0
            }

           this.addCat(cat)
            this.catForm=false
        },
     deleteCatButton(item){
       this.catactive[0]=item
       this.catactivename=item.name
       this.confirmDeleteDialog=true;
       

     },
      addSubCatButton(item){
        this.catactive[0]=item;
        this.subcatForm=true
      },

        addSubCatToDb(){     
        var parentid = this.catactive[0].id;
        var id = parentid+'-'+'sub1';
        var name = this.catname;        
                
        var childrens = this.catactive[0].childs;

        if(childrens>0){
                var pos=1
                var size = this.$store.state.catdb.length
           

            for(var i=0;i<size;i++){
              if(this.$store.state.catdb[i].id!=id){continue}else{
                pos+=1
                id=parentid+'-'+'sub'+pos
                i=0
              }
            }
            } 
            
        var payload={cat:this.catactive[0],ammount:1}
        this.updateCatChildCount(payload)
        var cat = {
              'id':id,'name':name,'desc':this.catdesc,'children':[],'childs':0,
              'parentid':parentid,'qtyprod':0,'invAlert':this.invAlert,'level':this.catactive[0].level+1
            }

           this.addCat(cat)
            this.subcatForm=false
        
        },
        modifCatButton(item){
          this.catactive[0]=item
          this.modifCatDialog=true
          
        },
        modifCatClose(){
         // this.treeviewCatItems=this.$store.getters.treeviewCatDb
          this.modifCatDialog=false
        },
        removeselectedcat(){
          
        //empeche la suppression d'une categorie contenant des enfants ou des produits
        if(this.catactive[0].children.length>0){
          this.confirmDeleteDialog=false
          this.errorCatChild=true}
          else{
          
          var payload = {id:this.catactive[0].id,newid:"uncategorized",catname:"Sin categoria"}
          this.modifProductCat(payload)
          this.deleteCat(this.catactive[0])
          this.confirmDeleteDialog=false
        }
        
        },
    },
  }
</script>